import prop from 'ramda/src/prop'
import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { NEW_FOOTER_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default () => prop(NEW_FOOTER_MODULE_ID, moduleDescriptions)
